/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type OAuthAppAwsAccountCategoryEnum = 'ADMIN' | 'SHADOW';

export const OAuthAppAwsAccountCategoryEnum = {

    ADMIN: 'ADMIN' as OAuthAppAwsAccountCategoryEnum,

    SHADOW: 'SHADOW' as OAuthAppAwsAccountCategoryEnum
};

